import { render, staticRenderFns } from "./CastleQna.vue?vue&type=template&id=3e7f5052&scoped=true"
import script from "./CastleQna.vue?vue&type=script&lang=js"
export * from "./CastleQna.vue?vue&type=script&lang=js"
import style0 from "./CastleQna.vue?vue&type=style&index=0&id=3e7f5052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f5052",
  null
  
)

export default component.exports